import React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";
import approachImg from "../images/APPROACH.png";
import dotImage from "../images/Dot.png";

const Approach = ({ approach }) => {
  return (
    <section className="container mt-17 mb-5">
      <div className="row">
        <div className="col-12 col-lg-6 order-2 order-lg-1 mt-2 mt-sm-0 mt-md-0">
          <div className="position-relative pt-5 pt-lg-0">
            <div className="position-absolute approach-img-position">
              <img src={approachImg} className="img-fluid" alt="" />
            </div>
            <h1 className="fs-56 lh-56 gilroy-bold pt-5 pt-lg-0 text-center text-lg-start">
              {approach?.title}
            </h1>
          </div>
          <p
            className="fs-20 lh-32 mt-5 approach-description text-spanish-gray text-align-justify"
            dangerouslySetInnerHTML={{ __html: approach?.description }}
          />
          <div className="mt-5">
            <a
              href={approach?.button_link}
              className="d-inline-block px-5 py-4 bg-american-yellow fs-14 text-decoration-none text-white"
            >
              {approach?.button_text}
            </a>
          </div>
        </div>
        <div className="col-12 col-lg-6 position-relative d-flex justify-content-center order-1 order-lg-2">
          <img
            src={`${IMAGE_BASE_URL}/${approach?.image}`}
            loading="lazy"
            className="img-fluid approach-image"
            alt=""
          />
          <img
            src={dotImage}
            loading="lazy"
            className="animation-up-down dot-image"
            alt=""
            style={{ zIndex: "-1" }}
          />
        </div>
      </div>
    </section>
  );
};

export default Approach;
